export const navigation = {
  brand: "reactDirectorAdmin",
  leftLinks: [],
  rightLinks: [
    {
      label: "Dashboard",
      link: "/dashboard",
      view: "home",
      isRouteBtn: true,
    },
    {
      label: "About",
      link: "/about",
      view: "about",
      isRouteBtn: true,
    },
  ],

  mainNavigation: {
    admin: [
      {
        id: 1,
        group: "Dashboard",
        menus: [
          {
            name: "Dashboard",
            linkKey: "DASHBOARD",
            linkTo: "/dashboard",
            faIconName: "fa-home",
          },
        ],
      },
      {
        id: 2,
        group: "Merchants",
        linkKey: "merchantMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_MERCHANT",
            linkTo: "/addMerchant",
            faIconName: "fa-plus",
          },
          {
            name: "Merchant List",
            linkKey: "LIST_MERCHANT",
            linkTo: "/merchantList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 3,
        group: "Offers",
        linkKey: "offerMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_CONTRACT",
            linkTo: "/addContract",
            faIconName: "fa-plus",
          },
          {
            name: "View Contracts",
            linkKey: "LIST_CONTRACT",
            linkTo: "/contractList",
            faIconName: "fa-eye",
          },
          {
            name: "View Offers",
            linkKey: "VIEW_OFFERS",
            linkTo: "/dealList",
            faIconName: "fa-eye",
          },
          {
            name: "Update Offer Order",
            linkTo: "/offerOrder",
            linkKey: "UPDATE_OFFER_ORDER",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 10,
        group: "Products",
        linkKey: "productsMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_PRODUCTS",
            linkTo: "/addProduct",
            faIconName: "fa-plus",
          },
          {
            name: "View Products",
            linkKey: "VIEW_PRODUCTS",
            linkTo: "/productList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 11,
        group: "Auctions",
        linkKey: "auctionsMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_AUCTIONS",
            linkTo: "/addAuction",
            faIconName: "fa-plus",
          },
          {
            name: "View Auctions",
            linkKey: "VIEW_AUCTIONS",
            linkTo: "/auctionList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 4,
        group: "Marketing",
        linkKey: "marketingMenu",
        menus: [
          {
            name: "Email Manager",
            linkTo: "/",
            linkKey: "emailManagerMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Email Manager",
              menus: [
                {
                  name: "Campaign Manager",
                  linkKey: "LIST_COMPAIGN",
                  linkTo: "/email-manager/overview",
                  faIconName: "fa-eye",
                },
                {
                  name: "Import Subscribers",
                  linkKey: "IMPORT_SUBSCRIBER",
                  linkTo: "/import-subscriber",
                  faIconName: "fa-eye",
                },
                {
                  name: "Export Subscribers",
                  linkKey: "EXPORT_SUBSCRIBER",
                  linkTo: "/export-subscriber",
                  faIconName: "fa-eye",
                },
                {
                  name: "Market",
                  linkKey: "LIST_MARKET",
                  linkTo: "/market/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "Postup",
                  linkKey: "LIST_POSTUP",
                  linkTo: "/postup/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Promo Codes",
            linkKey: "LIST_PROMO_CODE",
            linkTo: "/promoList",
            faIconName: "fa-eye",
          },
          {
            name: "Affiliates",
            linkKey: "LIST_AFFILIATE",
            linkTo: "/affiliateList",
            faIconName: "fa-eye",
          },
          // {
          //   name: 'Stores',
          //   linkTo: '/stores',
          //   linkKey: 'STORES',
          //   faIconName: 'fa-eye'
          // },
          {
            name: "Notification",
            linkTo: "/notification/list",
            linkKey: "NOTIFICATION",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 5,
        group: "Search",
        linkKey: "searchMenu",
        menus: [
          {
            name: "Customers",
            linkTo: "/customerList",
            linkKey: "CUSTOMER_LIST",
            faIconName: "fa-eye",
          },
          {
            name: "Orders",
            linkTo: "/orders",
            linkKey: "ORDERS",
            faIconName: "fa-eye",
          },
          {
            name: "Vouchers",
            linkTo: "/",
            linkKey: "voucherMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Vouchers",
              menus: [
                {
                  name: "View Voucher List",
                  linkKey: "LIST_VOUCHERS",
                  linkTo: "/voucherList",
                  faIconName: "fa-eye",
                },

                {
                  name: "Generate Vouchers",
                  linkKey: "GENERATE_VOUCHER",
                  linkTo: "/generateVoucher",
                  faIconName: "fa-plus",
                },
              ],
            },
          },
          {
            name: "General Search",
            linkTo: "/sitelookup",
            linkKey: "GENERAL_SEARCH",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 6,
        group: "Reports",
        linkKey: "reportMenu",
        menus: [
          {
            name: "Buyers",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 51,
              group: "Buyers",
              menus: [
                {
                  name: "Buyer Metrics",
                  linkTo: "/report/buyer",
                  linkKey: "BUYER_METRICS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Coupon Offers",
                  linkKey: "COUPONOFFERS_REPORT",
                  linkTo: "/report/couponoffers",
                  faIconName: "fa-eye",
                },
                {
                  name: "Deal Buyer Report",
                  linkKey: "DEALBUYER_REPORT",
                  linkTo: "/report/dealbuyer",
                  faIconName: "fa-eye",
                },
                {
                  name: "Subscribers",
                  linkKey: "SUBSCRIBERS_REPORT",
                  linkTo: "/report/email/subscribers",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Commissions",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 52,
              group: "Commissions",
              menus: [
                {
                  name: "Affiliate Commissions",
                  linkKey: "AFFILIATE_COMMISSION",
                  linkTo: "/report/affiliate/commissions",
                  faIconName: "fa-eye",
                },
                {
                  name: "Employee Commissions",
                  linkTo: "/report/commissions",
                  linkKey: "EMPLOYEE_COMISSIONS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Merchant",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Merchant",
              menus: [
                {
                  name: "Payout By Offer",
                  linkTo: "/report/payout-by-offer",
                  linkKey: "MERCHANT_PAYOUT_BY_OFFER",
                  faIconName: "fa-eye",
                },
                {
                  name: "Pay On Redemption",
                  linkTo: "/report/merchant-payon",
                  linkKey: "PAY_ON_REDEMPTION",
                  faIconName: "fa-eye",
                },
                {
                  name: "Payouts",
                  linkKey: "MERCHANT_PAYOUTS",
                  linkTo: "/report/merchant-payout",
                  faIconName: "fa-eye",
                },
                {
                  name: "Paid Payouts",
                  linkKey: "MERCHANT_PAID_PAYOUT",
                  linkTo: "/report/payout-paid",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Revenue",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 54,
              group: "Revenue",
              menus: [
                {
                  name: "Net Revenue Report",
                  linkTo: "/report/netrevenue",
                  linkKey: "NET_REVENUE_REPORTS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Revenue Report",
                  linkTo: "/report/revenue",
                  linkKey: "REVENUE_REPORTS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Sales",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 53,
              group: "Sales",
              menus: [
              
                {
                  name: "Sales By Offer",
                  linkTo: "/report/sales-by-offer",
                  linkKey: "SALES_BY_OFFER",
                  faIconName: "fa-eye",
                },
                 {
                  name: "No Sales Offer Report",
                  linkTo: "/report/zerosale-by-offer",
                  linkKey: "SALES_BY_OFFER",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Overview",
                  linkTo: "/report/sales-overview",
                  linkKey: "SALESOVERVIEW_REPORT",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Performance",
                  linkTo: "/report/sales-performance",
                  linkKey: "SALES_PERFORMANCE",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Report",
                  linkKey: "SALES_REPORT",
                  linkTo: "/report/sales",
                  faIconName: "fa-eye",
                },
               
               
              ],
            },
          },
          {
            name: "Recurring",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 53,
              group: "Recurring",
              menus: [
                {
                  name: "Recurring Customer Report",
                  linkKey: "TRANSACTION_REPORT",
                  linkTo: "/report/CustomerRecurring",
                  faIconName: "fa-eye",
                },
                {
                  name: "Recurring Payment Report",
                  linkKey: "TRANSACTION_REPORT",
                  linkTo: "/report/RecurringPayment",
                  faIconName: "fa-eye",
                },
                {
                  name: "Failed Recurring Report",
                  linkKey: "TRANSACTION_REPORT",
                  linkTo: "/report/FailedRecurring",
                  faIconName: "fa-eye",
                },
              ],
            },
          },

            {
            name: "Transactions",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 54,
              group: "Transactions",
              menus: [
                {
                  name: "Inventory",
                  linkKey: "INVENTORY_REPORT",
                  linkTo: "/report/offer-inventory",
                  faIconName: "fa-eye",
                },
                {
                  name: "Refunds",
                  linkKey: "REFUNDS_REPORT",
                  linkTo: "/report/refund",
                  faIconName: "fa-eye",
                },

                 {
                  name: "Archive Refunds",
                  linkKey: "REFUNDS_ARCHIVE_REPORT",
                  linkTo: "/report/archiverefund",
                  faIconName: "fa-eye",
                },
              
                {
                  name: "Transactions",
                  linkKey: "TRANSACTION_REPORT",
                  linkTo: "/report/transaction",
                  faIconName: "fa-eye",
                },
                
                {
                  name: "Simple Transaction",
                  linkKey: "SIMPLETRANSACTION_REPORT",
                  linkTo: "/report/simpletransaction",
                  faIconName: "fa-eye",
                },
                 {
                  name: "Promo Code Report",
                  linkTo: "/report/promoreport",
                  linkKey: "PROMO_CODE_REPORT",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
        ],
      },
      {
        id: 7,
        group: "Feedback",
        linkKey: "feedbackMenu",
        menus: [
          {
            name: "Manage Questions",
            linkKey: "MANAGE_QUESTIONS",
            linkTo: "/questions",
            faIconName: "fa-eye",
          },
          {
            name: "Manage Reviews",
            linkKey: "MANAGE_REVIEWS",
            linkTo: "/offerReviews",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 8,
        group: "Site Settings",
        linkKey: "siteSettingMenu",
        menus: [
          {
            name: "Account Information",
            linkKey: "EDIT_SITE",
            linkTo: "/editSite",
            faIconName: "fa-eye",
          },
          {
            name: "Charity",
            linkTo: "/",
            linkKey: "cherityMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 42,
              group: "Charity",
              menus: [
                {
                  name: "Add Charity",
                  linkKey: "CHARITY_ADD",
                  linkTo: "/charity-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "Charity List",
                  linkKey: "CHARITY_LIST",
                  linkTo: "/charity/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Cities",
            linkKey: "CITY_LISTING",
            linkTo: "/cityStatus",
            faIconName: "fa-eye",
          },
          {
            name: "Categories",
            linkKey: "LIST_CATEGORY",
            linkTo: "/categories",
            faIconName: "fa-eye",
          },
          {
            name: "Export Users",
            linkKey: "EXPORT_USERS",
            linkTo: "/export/users",
            faIconName: "fa-eye",
          },
          {
            name: "Design Center",
            linkTo: "/",
            linkKey: "designCenterMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Design Center",
              menus: [
                {
                  name: "Assets Manager",
                  linkKey: "LIST_ASSET",
                  linkTo: "/assets/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "Color Manager",
                  linkKey: "LIST_ASSET_COLOR",
                  linkTo: "/assets/color/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "FAQs",
                  linkKey: "LIST_FAQ",
                  linkTo: "/faqList",
                  faIconName: "fa-eye",
                },
                {
                  name: "Email Templates",
                  linkKey: "EMAIL_TEMPLATE",
                  linkTo: "/emailTemplate",
                  faIconName: "fa-eye",
                },
                {
                  name: "Static Pages",
                  linkKey: "PAGE_TEMPLATE",
                  linkTo: "/manageTermsPolicies",
                  faIconName: "fa-eye",
                },
                {
                  name: "Page Templates",
                  linkKey: "CONTRACT_TEMPLATE",
                  linkTo: "/page-template",
                  faIconName: "fa-eye",
                },
                {
                  name: "Custom Pages",
                  linkKey: "CONTRACT_TEMPLATE",
                  linkTo: "/asset/custompage/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Form Settings",
            linkTo: "/",
            linkKey: "formSettingMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 44,
              group: "Form Settings",
              menus: [
                {
                  name: "Become A Partner",
                  linkKey: "FORM_SETTINGS",
                  linkTo: "/form-setting/become-a-partner",
                  faIconName: "fa-eye",
                },
                {
                  name: "Other Forms",
                  linkKey: "FORM_SETTINGS",
                  linkTo: "/form-setting/reg-subs",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Email Settings",
            linkKey: "EMAIL_SETTING",
            linkTo: "/emailSetting",
            faIconName: "fa-eye",
          },
          {
            name: "Employees",
            linkTo: "/",
            linkKey: "employeeMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 42,
              group: "Employees",
              menus: [
                {
                  name: "Manage User",
                  linkTo: "/userList",
                  linkKey: "LIST_EMPLOYEE",
                  faIconName: "fa-eye",
                },
                {
                  name: "Create New",
                  linkTo: "/addSubAdmin",
                  linkKey: "ADD_EMPLOYEE",
                  faIconName: "fa-plus",
                },
                {
                  name: "Roles",
                  linkTo: "/",
                  linkKey: "MANAGE_ROLES",
                  faIconName: "fa-eye",
                  subMenu: {
                    id: 111,
                    group: "Roles",
                    menus: [
                      {
                        name: "Add Role",
                        linkTo: "/add-role",
                        linkKey: "ADD_ROLE",
                        faIconName: "fa-eye",
                      },
                      {
                        name: "List Role",
                        linkTo: "/role-list",
                        linkKey: "LIST_ROLE",
                        faIconName: "fa-eye",
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            name: "Payments",
            linkTo: "/",
            linkKey: "paymentsMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 43,
              group: "Payments",
              menus: [
                {
                  name: "Payments Settings",
                  linkKey: "PAYMENT_SETTING",
                  linkTo: "/payment-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "Payout Terms",
                  linkTo: "/payout-terms/list",
                  linkKey: "PAYMENT_TERMS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Settings",
            linkTo: "/",
            linkKey: "apiseomainMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 43,
              group: "Settings",
              menus: [
                {
                  name: "API Settings",
                  linkKey: "API_SETTINGS",
                  linkTo: "/api-settings",
                  faIconName: "fa-eye",
                },
                {
                  name: "Cart Settings",
                  linkKey: "CART_SETTINGS",
                  linkTo: "/cart-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "SEO Settings",
                  linkTo: "/seo-settings",
                  linkKey: "SEO_SETTINGS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Account Settings",
                  linkKey: "ACCOUNT_SETTINGS",
                  linkTo: "/account-settings",
                  faIconName: "fa-eye",
                },
                {
                  name: "City Passwords",
                  linkKey: "CITY_PASSWORDS",
                  linkTo: "/city-password",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
        ],
      },
      {
        id: 9,
        group: "Announcements",
        menus: [
          {
            name: "Announcements",
            linkKey: "ANNOUNCEMENTS_LIST",
            linkTo: "/announcements",
            faIconName: "glyphicon glyphicon-eye-open",
          },
        ],
      },
    ],
    default: [
      {
        id: 1,
        group: "Dashboard",
        menus: [
          {
            name: "Dashboard",
            linkKey: "DASHBOARD",
            linkTo: "/dashboard",
            faIconName: "fa-home",
          },
        ],
      },
      {
        id: 21,
        group: "Voucher",
        menus: [
          {
            name: "Voucher Lists",
            linkKey: "MERCHANT_VOUCHER",
            linkTo: "/merchant/voucher/list",
            faIconName: "fa-eye",
          },
        ],
      },

        {
        id: 21,
        group: "Voucher",
        menus: [
          {
            name: "Voucher Archived Lists",
            linkKey: "MERCHANT_VOUCHER",
            linkTo: "/merchant/archivevoucher/list",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 22,
        group: "Contract",
        menus: [
          {
            name: "Contract",
            linkKey: "MERCHANT_CONTRACT",
            linkTo: "/contract/view",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 23,
        group: "Deal Buyer List",
        menus: [
          {
            name: "Deal Buyer List",
            linkKey: "MERCHANT_DASHBOARD_DEAL_BUYER_LIST",
            linkTo: "/deal-buyer-list",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 23,
        group: "Tracking Numbers",
        menus: [
          {
            name: "Tracking Numbers",
            linkKey: "MERCHANT_TRACKING",
            linkTo: "/trackingnumbers/List",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 23,
        group: "Payables",
        menus: [
          {
            name: "Payables",
            linkKey: "MERCHANT_PAYABLES",
            linkTo: "/payables",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 24,
        group: "Questions",
        menus: [
          {
            name: "Questions",
            linkKey: "SALESMANAGER_QUESTION",
            linkTo: "/question/pending",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 25,
        group: "Sales Team",
        menus: [
          {
            name: "Sales Team",
            linkKey: "SALESMANAGER_TEAM",
            linkTo: "/team/progress",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 2,
        group: "Merchants",
        linkKey: "merchantMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_MERCHANT",
            linkTo: "/addMerchant",
            faIconName: "fa-plus",
          },
          {
            name: "Merchant List",
            linkKey: "LIST_MERCHANT",
            linkTo: "/merchantList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 3,
        group: "Offers",
        linkKey: "offerMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_CONTRACT",
            linkTo: "/addContract",
            faIconName: "fa-plus",
          },
          {
            name: "View Contracts",
            linkKey: "LIST_CONTRACT",
            linkTo: "/contractList",
            faIconName: "fa-eye",
          },
          {
            name: "View Offers",
            linkKey: "VIEW_OFFERS",
            linkTo: "/dealList",
            faIconName: "fa-eye",
          },
          {
            name: "Update Offer Order",
            linkTo: "/offerOrder",
            linkKey: "UPDATE_OFFER_ORDER",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 10,
        group: "Products",
        linkKey: "productsMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_PRODUCTS",
            linkTo: "/addProduct",
            faIconName: "fa-plus",
          },
          {
            name: "View Products",
            linkKey: "VIEW_PRODUCTS",
            linkTo: "/productList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 11,
        group: "Auctions",
        linkKey: "auctionsMenu",
        menus: [
          {
            name: "Create New",
            linkKey: "ADD_AUCTIONS",
            linkTo: "/addAuction",
            faIconName: "fa-plus",
          },
          {
            name: "View Auctions",
            linkKey: "VIEW_AUCTIONS",
            linkTo: "/auctionList",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 4,
        group: "Marketing",
        linkKey: "marketingMenu",
        menus: [
          {
            name: "Email Manager",
            linkTo: "/",
            linkKey: "emailManagerMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Email Manager",
              menus: [
                {
                  name: "Campaign Manager",
                  linkKey: "LIST_COMPAIGN",
                  linkTo: "/email-manager/overview",
                  faIconName: "fa-eye",
                },
                {
                  name: "Import Subscribers",
                  linkKey: "IMPORT_SUBSCRIBER",
                  linkTo: "/import-subscriber",
                  faIconName: "fa-eye",
                },
                {
                  name: "Export Subscribers",
                  linkKey: "EXPORT_SUBSCRIBER",
                  linkTo: "/export-subscriber",
                  faIconName: "fa-eye",
                },
                {
                  name: "Market",
                  linkKey: "LIST_MARKET",
                  linkTo: "/market/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "Postup",
                  linkKey: "LIST_POSTUP",
                  linkTo: "/postup/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Promo Codes",
            linkKey: "LIST_PROMO_CODE",
            linkTo: "/promoList",
            faIconName: "fa-eye",
          },
          {
            name: "Affiliates",
            linkKey: "LIST_AFFILIATE",
            linkTo: "/affiliateList",
            faIconName: "fa-eye",
          },
          // {
          //   name: 'Stores',
          //   linkTo: '/stores',
          //   linkKey: 'STORES',
          //   faIconName: 'fa-eye'
          // },
          {
            name: "Notification",
            linkTo: "/notification/list",
            linkKey: "NOTIFICATION",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 5,
        group: "Search",
        linkKey: "searchMenu",
        menus: [
          {
            name: "Customers",
            linkTo: "/customerList",
            linkKey: "CUSTOMER_LIST",
            faIconName: "fa-eye",
          },
          {
            name: "Orders",
            linkTo: "/orders",
            linkKey: "ORDERS",
            faIconName: "fa-eye",
          },
          {
            name: "Vouchers",
            linkTo: "/",
            linkKey: "voucherMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Vouchers",
              menus: [
                {
                  name: "View Voucher List",
                  linkKey: "LIST_VOUCHERS",
                  linkTo: "/voucherList",
                  faIconName: "fa-eye",
                },
                {
                  name: "Generate Vouchers",
                  linkKey: "GENERATE_VOUCHER",
                  linkTo: "/generateVoucher",
                  faIconName: "fa-plus",
                },
              ],
            },
          },
          {
            name: "General Search",
            linkTo: "/sitelookup",
            linkKey: "GENERAL_SEARCH",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 6,
        group: "Reports",
        linkKey: "reportMenu",
        menus: [
          {
            name: "Buyers",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 51,
              group: "Buyers",
              menus: [
                {
                  name: "Buyer Metrics",
                  linkTo: "/report/buyer",
                  linkKey: "BUYER_METRICS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Coupon Offers",
                  linkKey: "COUPONOFFERS_REPORT",
                  linkTo: "/report/couponoffers",
                  faIconName: "fa-eye",
                },
                {
                  name: "Deal Buyer Report",
                  linkKey: "DEALBUYER_REPORT",
                  linkTo: "/report/dealbuyer",
                  faIconName: "fa-eye",
                },
                {
                  name: "Subscribers",
                  linkKey: "SUBSCRIBERS_REPORT",
                  linkTo: "/report/email/subscribers",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Commissions",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 52,
              group: "Commissions",
              menus: [
                {
                  name: "Affiliate Commissions",
                  linkKey: "AFFILIATE_COMMISSION",
                  linkTo: "/report/affiliate/commissions",
                  faIconName: "fa-eye",
                },
                {
                  name: "Employee Commissions",
                  linkTo: "/report/commissions",
                  linkKey: "EMPLOYEE_COMISSIONS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Merchant",
            linkTo: "/",
            linkKey: "merchantPayout",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Merchant",
              menus: [
                {
                  name: "Pay On Redemption",
                  linkTo: "/report/merchant-payon",
                  linkKey: "PAY_ON_REDEMPTION",
                  faIconName: "fa-eye",
                },
                {
                  name: "Payout By Offer",
                  linkTo: "/report/payout-by-offer",
                  linkKey: "MERCHANT_PAYOUT_BY_OFFER",
                  faIconName: "fa-eye",
                },
                {
                  name: "Payouts",
                  linkKey: "MERCHANT_PAYOUTS",
                  linkTo: "/report/merchant-payout",
                  faIconName: "fa-eye",
                },
                {
                  name: "Paid Payouts",
                  linkKey: "MERCHANT_PAID_PAYOUT",
                  linkTo: "/report/payout-paid",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Revenue",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 54,
              group: "Revenue",
              menus: [
                {
                  name: "Net Revenue Report",
                  linkTo: "/report/netrevenue",
                  linkKey: "NET_REVENUE_REPORTS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Revenue Report",
                  linkTo: "/report/revenue",
                  linkKey: "REVENUE_REPORTS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
                   name: "Sales",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 59,
              group: "Sales",
              menus: [
              
                {
                  name: "Sales By Offer",
                  linkTo: "/report/sales-by-offer",
                  linkKey: "SALES_BY_OFFER",
                  faIconName: "fa-eye",
                },
                 {
                  name: "No Sales Offer Report",
                  linkTo: "/report/zerosale-by-offer",
                  linkKey: "SALES_BY_OFFER",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Overview",
                  linkTo: "/report/sales-overview",
                  linkKey: "SALESOVERVIEW_REPORT",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Performance",
                  linkTo: "/report/sales-performance",
                  linkKey: "SALES_PERFORMANCE",
                  faIconName: "fa-eye",
                },
                {
                  name: "Sales Report",
                  linkKey: "SALES_REPORT",
                  linkTo: "/report/sales",
                  faIconName: "fa-eye",
                },
               
              ],
            },
          },
{
            name: "Transactions",
            linkTo: "/",
            linkKey: "reportMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 60,
              group: "Transactions",
              menus: [
                {
                  name: "Inventory",
                  linkKey: "INVENTORY_REPORT",
                  linkTo: "/report/offer-inventory",
                  faIconName: "fa-eye",
                },
                {
                  name: "Refunds",
                  linkKey: "REFUNDS_REPORT",
                  linkTo: "/report/refund",
                  faIconName: "fa-eye",
                },

                 {
                  name: "Archive Refunds",
                  linkKey: "REFUNDS_ARCHIVE_REPORT",
                  linkTo: "/report/archiverefund",
                  faIconName: "fa-eye",
                },
              
                {
                  name: "Transactions",
                  linkKey: "TRANSACTION_REPORT",
                  linkTo: "/report/transaction",
                  faIconName: "fa-eye",
                },
                
                {
                  name: "Simple Transaction",
                  linkKey: "SIMPLETRANSACTION_REPORT",
                  linkTo: "/report/simpletransaction",
                  faIconName: "fa-eye",
                },
                {
                  name: "Promo Code Report",
                  linkTo: "/report/promoreport",
                  linkKey: "PROMO_CODE_REPORT",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
      ],
      },
      {
        id: 7,
        group: "Feedback",
        linkKey: "feedbackMenu",
        menus: [
          {
            name: "Manage Questions",
            linkKey: "MANAGE_QUESTIONS",
            linkTo: "/questions",
            faIconName: "fa-eye",
          },
          {
            name: "Manage Reviews",
            linkKey: "MANAGE_REVIEWS",
            linkTo: "/offerReviews",
            faIconName: "fa-eye",
          },
        ],
      },
      {
        id: 8,
        group: "Site Settings",
        linkKey: "siteSettingMenu",
        menus: [
          {
            name: "Account Information",
            linkKey: "EDIT_SITE",
            linkTo: "/editSite",
            faIconName: "fa-eye",
          },
          {
            name: "Charity",
            linkTo: "/",
            linkKey: "cherityMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 42,
              group: "Charity",
              menus: [
                {
                  name: "Add Charity",
                  linkKey: "CHARITY_ADD",
                  linkTo: "/charity-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "Charity List",
                  linkKey: "CHARITY_LIST",
                  linkTo: "/charity/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Cities",
            linkKey: "CITY_LISTING",
            linkTo: "/cityStatus",
            faIconName: "fa-eye",
          },
          {
            name: "Categories",
            linkKey: "LIST_CATEGORY",
            linkTo: "/categories",
            faIconName: "fa-eye",
          },
          {
            name: "Export Users",
            linkKey: "EXPORT_USERS",
            linkTo: "/export/users",
            faIconName: "fa-eye",
          },
          {
            name: "Design Center",
            linkTo: "/",
            linkKey: "designCenterMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 41,
              group: "Design Center",
              menus: [
                {
                  name: "Assets Manager",
                  linkKey: "LIST_ASSET",
                  linkTo: "/assets/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "Color Manager",
                  linkKey: "LIST_ASSET_COLOR",
                  linkTo: "/assets/color/list",
                  faIconName: "fa-eye",
                },
                {
                  name: "FAQs",
                  linkKey: "LIST_FAQ",
                  linkTo: "/faqList",
                  faIconName: "fa-eye",
                },
                {
                  name: "Email Templates",
                  linkKey: "EMAIL_TEMPLATE",
                  linkTo: "/emailTemplate",
                  faIconName: "fa-eye",
                },
                {
                  name: "Static Pages",
                  linkKey: "PAGE_TEMPLATE",
                  linkTo: "/manageTermsPolicies",
                  faIconName: "fa-eye",
                },
                {
                  name: "Page Templates",
                  linkKey: "CONTRACT_TEMPLATE",
                  linkTo: "/page-template",
                  faIconName: "fa-eye",
                },
                {
                  name: "Custom Pages",
                  linkKey: "CONTRACT_TEMPLATE",
                  linkTo: "/asset/custompage/list",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Form Settings",
            linkTo: "/",
            linkKey: "formSettingMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 44,
              group: "Form Settings",
              menus: [
                {
                  name: "Become A Partner",
                  linkKey: "FORM_SETTINGS",
                  linkTo: "/form-setting/become-a-partner",
                  faIconName: "fa-eye",
                },
                {
                  name: "Other Forms",
                  linkKey: "FORM_SETTINGS",
                  linkTo: "/form-setting/reg-subs",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Email Settings",
            linkKey: "EMAIL_SETTING",
            linkTo: "/emailSetting",
            faIconName: "fa-eye",
          },
          {
            name: "Employees",
            linkTo: "/",
            linkKey: "employeeMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 42,
              group: "Employees",
              menus: [
                {
                  name: "Manage User",
                  linkTo: "/userList",
                  linkKey: "LIST_EMPLOYEE",
                  faIconName: "fa-eye",
                },
                {
                  name: "Create New",
                  linkTo: "/addSubAdmin",
                  linkKey: "ADD_EMPLOYEE",
                  faIconName: "fa-plus",
                },
                {
                  name: "Roles",
                  linkTo: "/",
                  linkKey: "MANAGE_ROLES",
                  faIconName: "fa-eye",
                  subMenu: {
                    id: 111,
                    group: "Roles",
                    menus: [
                      {
                        name: "Add Role",
                        linkTo: "/add-role",
                        linkKey: "ADD_ROLE",
                        faIconName: "fa-eye",
                      },
                      {
                        name: "List Role",
                        linkTo: "/role-list",
                        linkKey: "LIST_ROLE",
                        faIconName: "fa-eye",
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            name: "Payments",
            linkTo: "/",
            linkKey: "paymentsMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 43,
              group: "Payments",
              menus: [
                {
                  name: "Payments Settings",
                  linkKey: "PAYMENT_SETTING",
                  linkTo: "/payment-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "Payout Terms",
                  linkTo: "/payout-terms/list",
                  linkKey: "PAYMENT_TERMS",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
          {
            name: "Settings",
            linkTo: "/",
            linkKey: "apiseomainMenu",
            faIconName: "fa-eye",
            submMenu: {
              id: 43,
              group: "Settings",
              menus: [
                {
                  name: "API Settings",
                  linkKey: "API_SETTINGS",
                  linkTo: "/api-settings",
                  faIconName: "fa-eye",
                },
                {
                  name: "Cart Settings",
                  linkKey: "API_SETTINGS",
                  linkTo: "/cart-setting",
                  faIconName: "fa-eye",
                },
                {
                  name: "SEO Settings",
                  linkTo: "/seo-settings",
                  linkKey: "SEO_SETTINGS",
                  faIconName: "fa-eye",
                },
                {
                  name: "Account Settings",
                  linkKey: "ACCOUNT_SETTINGS",
                  linkTo: "/account-settings",
                  faIconName: "fa-eye",
                },
                {
                  name: "City Passwords",
                  linkKey: "CITY_PASSWORDS",
                  linkTo: "/city-password",
                  faIconName: "fa-eye",
                },
              ],
            },
          },
        ],
      },
      {
        id: 9,
        group: "Announcements",
        menus: [
          {
            name: "Announcements",
            linkKey: "ANNOUNCEMENTS_LIST",
            linkTo: "/announcements",
            faIconName: "glyphicon glyphicon-eye-open",
          },
        ],
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/app/models/navigation.js